/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { lazy, Suspense } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Portfolio from './components/Portfolio';
import Faq from './components/Faq';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import { Routes, Route } from 'react-router-dom';

// Lazy load heavy components to drastically reduce initial JS payload
const BloomBuddy = lazy(() => import('./components/BloomBuddy'));
const PrecisionBowls = lazy(() => import('./components/PrecisionBowls'));
const GlucoDrive = lazy(() => import('./components/GlucoDrive'));
const BowlsCaptain = lazy(() => import('./components/BowlsCaptain'));
const BowlsAnalyser = lazy(() => import('./components/BowlsAnalyser'));
const CruxSum = lazy(() => import('./components/CruxSum'));
const QuigleyRaccoonApp = lazy(() => import('./components/QuigleyRaccoonApp'));
const Numerax = lazy(() => import('./components/Numerax'));
const Privacy = lazy(() => import('./components/Privacy'));
const Terms = lazy(() => import('./components/Terms'));
const BookDetailsPage = lazy(() => import('./components/BookDetailsPage'));

function Home() {
  return (
    <>
      <Hero />
      <Portfolio />
      <Faq />
    </>
  );
}

// Simple elegant page-load spinner for suspended routes
function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]" id="loading-spinner">
      <div className="w-8 h-8 border-2 border-emerald-800 border-t-transparent rounded-full animate-spin" id="loading-spinner-circle"></div>
    </div>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-[#FAF9F6] dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-300" id="app-root">
      <ScrollToTop />
      <BackToTop />
      <Header />
      <main id="app-main">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bloombuddy" element={<BloomBuddy />} />
            <Route path="/precisionbowls" element={<PrecisionBowls />} />
            <Route path="/glucodrive" element={<GlucoDrive />} />
            <Route path="/bowlscaptain" element={<BowlsCaptain />} />
            <Route path="/bowlsanalyser" element={<BowlsAnalyser />} />
            <Route path="/cruxsum" element={<CruxSum />} />
            <Route path="/quigley-app" element={<QuigleyRaccoonApp />} />
            <Route path="/quigleyraccoon" element={<QuigleyRaccoonApp />} />
            <Route path="/numerax" element={<Numerax />} />
            <Route path="/books/:id" element={<BookDetailsPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}



